import {
  PARENT_CATEGORY_LIST,
  CHECK_LIST_ITEMS,
  GET_CAT_BY_ID,
  CHECK_LIST,
  LOADING,
  NOT_FOUND
} from "../action/type";

const initialState = {
  list: [{}],
  items: [{}],
  checklist: [{}],
  loading:false,
  not_found: false
};
const checklists = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, list: action.payload ,loading:true,not_found:false};
    case NOT_FOUND:
      return { ...state, list: action.payload ,loading:false,not_found:true};
    case PARENT_CATEGORY_LIST:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    case GET_CAT_BY_ID:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    case CHECK_LIST_ITEMS:
      return { ...state, items: action.payload ,loading:false,not_found:false};
    case CHECK_LIST:
      return { ...state, checklist: action.payload ,loading:false,not_found:false};
    default:
      return state;
  }
};

export default checklists;
